







import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ErrorModel, SearchCriteriaModel, StoreConstants } from '@/types';
import Vue from 'vue';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import { mapActions, mapGetters } from 'vuex';
import { Search } from '@/types/constants/routes/search';

export default Vue.extend({
  name: 'FindDocument',
  data() {
    return {
      cabinetId: this.$route.params.cabinetId,
      isLoading: false,
      displayErrorFindingDocument: false,
      errorModel: {
        showHeader: false,
        message: `No existing documents were found`,
        showButton: false
      } as ErrorModel
    };
  },
  methods: {
    ...mapActions(StoreConstants.Search.ModuleName, [StoreConstants.Search.Actions.SetSearchCriteria])
  },
  computed: { ...mapGetters(StoreConstants.Search.ModuleName, [StoreConstants.Search.Getters.SearchCriteria]) },
  async mounted() {
    await Vue.nextTick();
    this.isLoading = true;
    const queryParams = this.$route?.query;
    const standardSearch = Object.entries(queryParams).map(([fieldKey, value]) => ({ fieldKey, value }));
    try {
      const searchCriteria = { cabinets: [this.cabinetId], standardSearch: standardSearch as any, documentTypes: [] as number[] } as SearchCriteriaModel;
      this[StoreConstants.Search.Actions.SetSearchCriteria](searchCriteria);
      this.$router.push({ name: Search.Results.name });
      this.isLoading = false;
    } catch (error) {
      this.$log(error);
      if (error instanceof Error) {
        this.errorModel.message = error.message;
        this.isLoading = false;
        this.displayErrorFindingDocument = true;
      }
    }
  },
  components: {
    LoadingSpinner,
    ErrorNotification
  }
});
